export enum EActiveStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}
